import React from "react";
import { useParameterizedQuery } from "react-fetching-library";
import { useNavigate } from "react-router-dom";
import { getPopupData, PopupsData } from "../../Actions/PopupsData";
import { useVersionState } from "../../Contexts/ApiVersionProvider";
import {
    cleseSectionData,
    setPopupsSectionData,
    usePopupsSectionDispatch,
    usePopupsSectionState
} from "../../Contexts/PopupsProvider";

export const PopupsModal:React.FunctionComponent = () => {
    const [isLoadData, setIsLoadData] = React.useState(false);
    const [activeIndex, setActiveIndex] = React.useState(0);

    const getPopupDataAction = useParameterizedQuery(getPopupData);

    const { data } = useVersionState()
    const version = React.useMemo( () => {
        return data?.versions?.popups
    }, [data] );

    const navigate = useNavigate()

    const popupsSectionState = usePopupsSectionState()
    const popupsSectionDispatch = usePopupsSectionDispatch()

    const closeModal = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        cleseSectionData(popupsSectionDispatch);
    }, [popupsSectionDispatch]);

    const clickItem = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>, item: PopupsData) => {
        e.preventDefault();
        cleseSectionData(popupsSectionDispatch);

        if( item.intetnal.length === 0 ){
            // eslint-disable-next-line no-restricted-globals
            window.open( item.external );
        }else{
            navigate(item.intetnal);
        }


    }, [popupsSectionDispatch])

    const popupsSection = React.useMemo( () => {
        return popupsSectionState.data
    }, [popupsSectionState.data]);

    const items:PopupsData[] = React.useMemo( ()=>{
        return popupsSection?.popups ?? [];
    }, [popupsSection] )

    const forceDownload = React.useMemo( () => {
        if (popupsSection === undefined || version === undefined) {
            setIsLoadData(false);
            return true
        }

        if (popupsSection.version !== version) {
            setIsLoadData(false);
            return true
        }

        setIsLoadData(true);
        return false
    }, [popupsSection, version] );

    React.useEffect(() => {
        if ( (forceDownload && version) || (version && version.length > 0 && !popupsSection && !isLoadData) ){
            setIsLoadData(true);

            if ( getPopupDataAction.loading ) return;

            getPopupDataAction.query(version).then(response => {
                if (response.payload) {
                    setPopupsSectionData(response.payload, popupsSectionDispatch).then();
                }
            });
        }
    }, [forceDownload, data, isLoadData, version, popupsSection, getPopupDataAction, popupsSectionDispatch]);

    const title = React.useMemo(() => {
        return  popupsSection?.title;
    }, [popupsSection?.title]);

    const isOpen = React.useMemo(()=>{
        let isOpenPop = popupsSection !== undefined
                // && 
                && popupsSection.popups !== undefined
                && popupsSection.popups.length > 0

        if (popupsSection?.isClosed){
            isOpenPop = false;
        }
        
        

        return isOpenPop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [popupsSection, popupsSection?.isClosed])

    if (!isOpen) return null;


    return (
        <div id="info-modal" className={`modal fade${isOpen ? ' in' : ''}`} tabIndex={-1} role="dialog"
                style={isOpen ? {display: "block"} : undefined}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={closeModal}><span
                            aria-hidden="true">&times;</span></button>
                        <h2 className="modal-title">{title}</h2>
                    </div>

                    <div className="modal-body">

                        <div id="carousel-example-generic" className="carousel slide" data-ride="carousel" >
                            <ol className="carousel-indicators">
                                {
                                    items.map( (item, index)  => (
                                        <li className={ activeIndex === index ? 'active': undefined } data-target="#carousel-example-generic" data-slide-to={index} key={item.id}></li>
                                    ) )
                                }
                            </ol>

                            <div className="carousel-inner" role="listbox" >
                                {
                                    items.map( (item, index)  => (
                                        <div className={`item${ activeIndex === index ? ' active': '' }`} >
                                            <img src={item.image} alt=""/>
                                            <div onClick={ e => {
                                                    clickItem(e, item)
                                                } }
                                                 className="carousel-caption"
                                                 style={{backgroundColor: 'rgba(0, 0, 0, 0.5)', cursor: 'pointer'}}
                                            >
                                                {item.title}
                                            </div>
                                        </div>
                                    ) )
                                }
                            </div>

                            <a className="left carousel-control" href="#carousel-example-generic" role="button"
                               data-slide="prev">
                                <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                                <span className="sr-only">Previous</span>
                            </a>
                            <a className="right carousel-control" href="#carousel-example-generic" role="button"
                               data-slide="next">
                                <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}